import { useEffect, useState } from "react";

/**
 * 입력값을 지정 지연(ms) 후에만 반영하는 디바운스 훅.
 * 검색어 입력처럼 매 키 입력마다 필터/요청이 튀는 것을 막는다(기본 250ms).
 */
export function useDebouncedValue<T>(value: T, delayMs = 250): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const id = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(id);
  }, [value, delayMs]);
  return debounced;
}
